<template>
    <div class="vh-center" :class="className">
        <div class="m-main">
            <div class="m-section vh-center" :style="{ height: h, maxHeight: h }">
                <el-row type="flex" class="flex-row">
                    <el-col :span="15" class="left-img">
                        <div class="login-logo">
                            <img src="../assets/img/logo11.png" alt="">
                        </div>
                        <img src="../assets/img/login-main.png" alt="" />
                    </el-col>
                    <el-col :span="9" class="right-form v-between">
                        <slot name="form"></slot>
                    </el-col>
                </el-row>
            </div>
            <vfooter />
        </div>
    </div>
</template>

<script>
import vfooter from '@/components/vfooter'

export default {
    props: ['className'],
    data(){
        return {
            h: `${ document.documentElement.clientHeight - 60 }px`,
        }
    },
    components: {
        vfooter
    },
    mounted(){
        let vm = this;
        window.onresize = ()=>{
            vm.h = `${ document.documentElement.clientHeight - 60}px`;
        }
    },
    methods: {

    }

}
</script>

<style lang="scss" scoped>
@import '../style/variable';
    .m-login, .m-register{
        background-image: url('../assets/img/login-bg.png');
        background-size: cover;
        height: 100%;
        min-height: 600px;
        min-width: 1000px;
        overflow: hidden;
        position: relative;
        width: 100%;
        .m-main{
            min-width: 972px;
            width: 66%;
            .m-section{
                // padding: 10px 0;
                max-width: 1296px;
                max-height: 720px;
                box-sizing: border-box;
                min-height: 550px;
                .flex-row{
                    max-height: 100%;
                    width: 100%;
                }
                .left-img{
                    max-height: 100%;
                    position: relative;
                    >img{
                        width: 100%;
                        border-top-left-radius: 6px;
                        border-bottom-left-radius: 6px;
                        height: 100%;
                    }
                    .login-logo{
                        position: absolute;
                        top: 20px;
                        left: 40px;
                        width: 150px;
                        img{
                            width: 100%;
                        }
                    }
                }
                .right-form{
                    background-color: $c1;
                    border-top-right-radius: 6px;
                    border-bottom-right-radius: 6px;
                    flex-direction: column;
                    align-items: center;
                }
            }
        }

    }
    .m-register{
        .right-form{
            padding: 30px 50px;
        }
    }
    .m-login{
        .right-form{
            padding: 80px 50px;
        }
    }

</style>
